// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1gsd_","vLegacy":"SelectSecondary_vLegacy__1Gubf","error":"SelectSecondary_error__M4_HN","disabled":"SelectSecondary_disabled__ZTfoJ"};